// extracted by mini-css-extract-plugin
export default {"settingsMenu":"SettingsMenu_settingsMenu__6HcgS"};